import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Switch, Select, Form, Input, InputNumber } from 'antd';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import useFetchOrganizationTypes from '../../hooks/fetchOrganizationTypes';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
// import useFetchRoles from '../../hooks/fetchRoles';
import { LeftCircleOutlined } from '@ant-design/icons';
import InputMask from 'react-input-mask';
import getMerchantById from '../../hooks/getMerchantById';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
console.log(app);
const { TextArea } = Input;

const EditMerchant = () => {
  const { t } = useTranslation(['common']);
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  let navigate = useNavigate();
  const token=getTokenfromUserObj();
  let user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  let merchantId = JSON.parse(localStorage.getItem('merchantId'));
  const merchantResp=getMerchantById(merchantId);
  let merchantObj = merchantResp.response ? merchantResp.response.data : [];
  console.log(merchantObj);
  const o = useFetchOrganizations();
  const orgs = o.response ? o.response.data : [];
  console.log(orgs);

  const [uploadObj, setUploadObj] = useState({});
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/merchant/update/${merchantId}`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          navigate('/merchant/view');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      merchantRef: values.merchantRef ? values.merchantRef : merchantObj.merchantRef,
      consumerKey: values.consumerKey ? values.consumerKey : merchantObj.consumerKey,
      consumerSecret: values.consumerSecret ? values.consumerSecret : merchantObj.consumerSecret,
      merchantName: values.merchantName ? values.merchantName : merchantObj.merchantName,
      paymentUrl: values.paymentUrl ? values.paymentUrl : merchantObj.paymentUrl,
      expireOn: values.expiresOn ? values.expiresOn : merchantObj.expireOn,
      organizationId: values.organizationId ? values.organizationId : merchantObj.organizationId,
      isActive: values.isActive === true ? 1 : 0,
      updatedByUserId: user.userId,
    });
    setShow(true);
  };
  console.log(uploadObj);
  const submitData = () => {
    console.log('calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // uploadData(uploadObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  function goBack() {
    navigate('/merchant/view',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                navigate('/merchant/view');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Merchant')} </h2>
          </div>{' '}
        </div>
        <div class='col mb-5 w-50 mt-4'>
          <div class='col-lg-9 align-self-center mt-2 mb-4'>
          {merchantResp.response? <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['merchantRef']:merchantObj.merchantRef,
                ['organizationId']: merchantObj.organizationId,
                ['merchantName']: merchantObj.merchantName,
                ['consumerKey']: merchantObj.consumerKey,
                ['consumerSecret']: merchantObj.consumerSecret,
                ['isActive']: merchantObj.isActive === 1 ? true : false,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {/* Select box for Role */}

              <Form.Item
                colon={false}
                label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: true,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Organization'
                >
                  {orgs
                    ? orgs.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item>
              <Form.Item
                label='Merchant ID'
                name='merchantRef'
                defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Merchant ID',
                  },
                ]}
              >
                <Input type='number' pattern='[0-9]*' placeholder='Enter Merchant ID' />
              </Form.Item>
              <Form.Item
                label='Merchant Name'
                name='merchantName'
                defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Enter Name',
                  },
                ]}
              >
                <Input placeholder='Enter Name' defaultValue={'Mx Merchant'} disabled={true} />
              </Form.Item>
              <Form.Item
                label='Consumer Key'
                name='consumerKey'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Consumer Key',
                  },
                ]}
              >
                <Input placeholder='Enter Consumer Key' />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Secret Key'
                name='consumerSecret'
                rules={[
                  {
                    required: true,
                    type: 'text',
                    message: 'Enter Consumer Secret Key',
                  },
                ]}
              >
                <Input placeholder='Enter Consumer Secret Key' />
              </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>

              {/* Select box for Organization */}

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to update Merchant?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}

                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Update
                </button>
              </Form.Item>
            </Form>    :" "} 
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMerchant;
